export const GET_CALENDAR = 'GET_CALENDAR';

export const getCalendar = (data) => (dispatch) => {
  dispatch({
    type: GET_CALENDAR,
    data: data,
  });
};